var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('img',{attrs:{"src":require("../assets/images/cuowu.png"),"width":"70","height":"70"}}),(this.$route.query.msg)?_c('h3',[_vm._v(_vm._s(this.$route.query.msg))]):_c('h3',[_vm._v("您没有权限访问该页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }